<template>
  <el-row>
    <el-col>
      <Filters
        class="mb-3"
        :resource="$sdk.assetmanufacturer"
        :filters.sync="filters"
        @apply="reload"
        @ready="load"
      />

      <el-card shadow="never">
        <Manufacturer
          ref="manufacturerTable"
          v-loading="loading"
          :manufacturers="manufacturers"
        >
          <template
            v-if="canUpdate || canDelete"
            v-slot:action="props"
          >
            <el-button
              v-if="canUpdate"
              size="mini"
              @click.native="showEditForm(props.Manufacturer)"
            >
              Edit
            </el-button>
            <el-button
              v-if="canDelete"
              size="mini"
              type="danger"
              @click.native="deleteManufacturer(props.Manufacturer)"
            >
              Delete
            </el-button>
          </template>
        </Manufacturer>
        <el-pagination
          class="text-center"
          :current-page.sync="manufacturers.page"
          :page-size.sync="manufacturers.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="manufacturers.total"
          @size-change="reload"
          @current-change="reload"
        />
      </el-card>
      <CreateEditForm
        ref="actionForm"
        @save="save"
        @reload="reload"
      />
    </el-col>
  </el-row>
</template>

<script>
import Manufacturer from '@/components/Application/Configuration/Assets/Manufacturer/Table'
import Filters from '@/components/Filters/Complex'
import CreateEditForm from '@/components/Application/Configuration/Assets/Manufacturer/CreateEditForm'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'

export default {
  components: {
    Manufacturer,
    Filters,
    CreateEditForm
  },
  data () {
    return {
      title: 'Manufacturer',
      breadcrumb:
      {
        name: 'Manufacturers',
        route: { name: 'configuration-assets-manufacturers' }
      },
      actions: [
        {
          hidden: this.$user.cannot(CREATE, 'assetmanufacturer'),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.$refs.actionForm.showCreateDialog()
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.reload()
        }
      ],
      filters: [],
      manufacturers: [],
      loading: false
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'assetmanufacturer')
    },
    canDelete () {
      return this.$user.can(DELETE, 'assetmanufacturer')
    }
  },
  methods: {
    load () {
      this.loading = true
      this
        .$sdk
        .asset_manufacturer
        .list(builder => {
          builder.filters = this.filters
          builder.order = 'created_at:desc'
        })
        .then(res => {
          this.manufacturers = res
        })
        .finally(() => { this.loading = false })
    },
    async reload () {
      this.loading = true

      try {
        await this.manufacturers.reload(builder => { builder.filters = this.filters })
      } catch {
        this.$message.error('Failed to load Asset Manufacturers')
      }

      this.loading = false
    },
    showEditForm (row) {
      this.$refs.actionForm.showEditForm(row)
    },
    save (form) {
      this.$sdk.asset_manufacturer.create({
        name: form.name,
        description: form.description
      })
        .then(res => {
          this.$message({ message: 'Successfully saved', type: 'success' })
          this.manufacturers.reload()
        })
        .finally(() => {
          this.$refs.actionForm.closeDialog()
        })
    },
    deleteManufacturer (manufacturer) {
      this.$confirm('Are you sure to delete this asset\'s manufacturer ?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.loading = false
        manufacturer.delete()
          .then(res => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => {
            this.reload()
            this.loading = true
          })
      }).catch(() => {})
    }
  }
}
</script>
